/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetAgentRequest as AgentApiContractSetAgentRequest } from '../../models/AgentApi/Contract/set-agent-request';

export interface ApiAgentSetAgentPost$Params {

/**
 * * Interface language
 */
  lang?: string;
      body?: AgentApiContractSetAgentRequest
}

export function apiAgentSetAgentPost(http: HttpClient, rootUrl: string, params?: ApiAgentSetAgentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgentSetAgentPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgentSetAgentPost.PATH = '/api/Agent/SetAgent';
